import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const NewVacacionesUserAdministrar = Loadable(lazy(() => import('views/user/AdministrarEmpleados/NewVacacionesView')));

const ListVacacionesUserAdministrar = Loadable(lazy(() => import('views/user/AdministrarEmpleados/ListVacacionesView')));

const NewPrestamosUserAdministrar = Loadable(lazy(() => import('views/user/AdministrarEmpleados/NewPrestamosView')));

const ListPrestamosUserAdministrar = Loadable(lazy(() => import('views/user/AdministrarEmpleados/ListPrestamosView')));

const AdministracionEmpleadosRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/new-vacaciones/:id_vacaciones',
            element: <NewVacacionesUserAdministrar />
        },
        {
            path: '/user/list-vacaciones',
            element: <ListVacacionesUserAdministrar />
        },
        {
            path: '/user/new-prestamos/:id_prestamos',
            element: <NewPrestamosUserAdministrar />
        },
        {
            path: '/user/list-prestamos',
            element: <ListPrestamosUserAdministrar />
        },
    ]
};

export default AdministracionEmpleadosRoutes;